<template>
  <div class="tracking" style="background-color: #f0f2f5">
    <b-row>
      <b-col class="mx-auto" cols="10">
        <b-row>
          <b-col
            col
            lg="4"
            md="8"
            sm="10"
            class="mx-auto"
            style="margin-top: 5%; margin-bottom: 5%"
          >
            <b-card class="trackCard">
              <b-form @submit="request">
                <!-- <b-card-text style="font-size: 14px;" class="text-center">
              We want to continue to support you and this <b>TRACKING</b> feature allows
              you to keep in step with any item you have order for through <b style="color:  #db0000;">Post Office</b>
              till when it reaches your doorstep.
            </b-card-text>-->

                <!-- <b-card-text style="font-size: 14px;" class="text-center">
              Provide us with a Tracking Number to view your items status with <b style="color:  #db0000;">ePosta</b>
            </b-card-text>-->

                <b-card-text style="font-size: 14px" class="text-center">
                  Track your Items, Applications and online Purchases by
                  entering The Tracking Number, Application Tracking Number and
                  your Purchase Order Tracking Number.
                </b-card-text>

                <br />

                <div class="form-group mb-3 input-group input-text-wrapper">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="background-color: #ffffff; border: none"
                    >
                      <font-awesome-icon icon="search" style="color: #ced4da" />
                    </span>
                  </div>
                  <b-form-input
                    class="track-text-input"
                    v-model="trck_no"
                    type="text"
                    required
                    placeholder="Enter Your Tracking Number"
                  ></b-form-input>
                </div>

                <b-form-group>
                  <b-button class="form-control signUpButtonCard" type="submit"
                    >Send Request &nbsp;
                    <b-spinner
                      v-if="trackSpinner"
                      small
                      label="Loading..."
                    ></b-spinner>
                  </b-button>
                </b-form-group>
              </b-form>
            </b-card>
          </b-col>

          <b-col
            col
            lg="4"
            md="8"
            sm="8"
            style="margin-top: 5%"
            class="mx-auto d-none d-sm-block"
          >
            <b-row v-for="item in getTracking" class="mx-auto" :key="item">
              <Timeline :data="item"></Timeline>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Timeline from "@/views/dashboard/delivery/Timeline";
export default {
  name: "Tracking",
  components: { Timeline },
  data() {
    return {
      trck_no: null,
    };
  },
  computed: {
    ...mapGetters(["getClientId", "getTracking", "getTrackingRequestError"]),
    tracking_response() {
      return this.getTracking;
    },
  },
  watch: {
    tracking_response() {},
    getTrackingRequestError() {
      this.$swal({
        title: "Error",
        text: "error.data.message",
      });
    },
  },
  methods: {
    ...mapActions(["makeTrackingRequest"]),
    request(e) {
      e.preventDefault();
      let data = {
        tracking_no: this.trck_no,
      };
      this.makeTrackingRequest(data);
    },
  },
};
</script>

<style scoped>
.track-text-input {
  border: none;
  font-size: 13px;
  color: #8898aa;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 5px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 5px;
}

.trackCard {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
}

.tracking {
  width: 100%;
  height: 100%;
  /*background-color: #c40000;
        background-size: cover;*/
}

.box {
  border-radius: 6px;
  margin: 50px;
  box-shadow: 8px 10px 28px #8a0010;
}

.prompt {
  color: #222;
  font-size: 14px;
}

.right {
  width: 50%;
  height: 100%;
  background-color: #fff;
  background-size: cover;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.title-bar {
  background: #db0000;
  padding: 15px;
}

.links {
  text-decoration: none;
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 30px;
}

.salutations {
  margin-top: 40px;
}

.form {
  width: 100%;
  margin-top: 35px;
  margin-left: 15px;
  margin-right: 15px;
}

.input {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 0;
  border-bottom: solid 2px #db0000;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  background: white;
}

.input:hover {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.input:focus {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.disclaimer {
  margin-top: 50px;
}

.button {
  width: 100%;
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}

.button:hover {
  background: #9f0012;
}
</style>
